import { DiscountType } from '@global/types/types';
import { SiteId } from 'wly-ecommerce-common';

export const Pages = {
  ROOT: '/',
  CHECKOUT: '/checkout',
  ORDER_CONFIRMATION: '/checkout/order-confirmation',
  SUBSCRIPTION_DETAILS: '/checkout/subscription-details',
  ERR404: '/404',
};

export const ELQForm = {
  endpoint: process.env.REACT_APP_ELQ_FORM_ENDPOINT,
  formName: process.env.REACT_APP_ELQ_FORM_NAME,
  siteID: process.env.REACT_APP_ELQ_SITE_ID,
  formStart: process.env.REACT_APP_ELQ_FORM_START,
};

export const AUTOCOMPLETE_URL = process.env.REACT_APP_AUTOCOMPLETE_URL;

export const AWS_COUNTRIES_URL = process.env.REACT_APP_AWS_COUNTRIES_URL;
export const CART_ID_ATTRIBUTE = process.env.REACT_APP_CART_ID_ATTRIBUTE;

export const GRAPHQL_URI = process.env.REACT_APP_VIAX_GRAPHQL_URI;

export const STRIPE_KEY = process.env.REACT_APP_STRIPE_PUBLIC_KEY;

export const WPS_PAYMENT_COMPONENT_URL =
  process.env.REACT_APP_WPS_COMPONENT_URL;
export const WPS_JS_CAPTCHA_RETRY_ATTEMPT =
  process.env.REACT_APP_WPS_JS_CAPTCHA_RETRY_ATTEMPT;
export const REACT_APP_WPS_DISABLE_CAPTCHA =
  process.env.REACT_APP_WPS_DISABLE_CAPTCHA === 'true';

export const WPS_PAYMENT_METHODS = { Card: 'Card' };

export const PAYMENT_ELEMENT_ID = 'payment-element';
export const PAYMENT_SUBMIT_BUTTON_ID = 'btn-payment-element-submit';

export const DEFAULT_PRICE_MODEL = 'WILEYCOM';

export const CART_CHECKOUT_BASE_URL =
  process.env.REACT_APP_CART_CHECKOUT_BASE_URL;
export const CART_PATH = '/cart';
export const CHECKOUT_PATH = '/checkout';
export const REGISTER_PATH = '/register';
export const LOGIN_PATH = '/login';

export const SUBSCRIPTION_SITE_NAMES = {
  subscription: 'Chemistry on Demand',
  ags: 'Architectural Graphic Standards',
  vet: 'VetConsult',
  spectrabase: 'Spectrabase',
  aigateway: 'Scholar Gateway',
};

export const CART_UID_URL_PARAM_KEY = 'order';

export const TEXTBOOK_RENTAL_CAT_ID = 'rental';
export const TEXTBOOK__ALTO_RENTAL_CAT_ID = 'Alta Rental';

export const TERMS_URL = process.env.REACT_APP_TERMS_URL;
export const POLICY_URL = process.env.REACT_APP_POLICY_URL;
export const RENTAL_TERMS_URL = process.env.REACT_APP_RENTAL_TERMS_URL;

// #start shared-global header/footer
export const AEM_RESOURCE_BASE_URL =
  process.env.REACT_APP_AEM_RESOURCE_BASE_URL;
export const AEM_HEADER_HEIGHT = 80;
// #end shared-global header/footer

export const BUNDLE_DISCOUNT_TITLE = 'BUNDLE PRICE';
export const SITEWIDE_DISCOUNT_TITLE = 'SALE';
export const FREETRIAL_TITLE = 'FREE TRIAL';
export const DISCOUNTS: Record<string, string> = {
  [DiscountType.ADD_DISCOUNT]: BUNDLE_DISCOUNT_TITLE,
  [DiscountType.SITEWIDE_PRODUCT_DISCOUNT]: SITEWIDE_DISCOUNT_TITLE,
  [DiscountType.SITEWIDE_SITE_ID_DISCOUNT]: SITEWIDE_DISCOUNT_TITLE,
  [DiscountType.FREETRIAL]: FREETRIAL_TITLE,
};

export const DEFAULT_IMAGE = `${AEM_RESOURCE_BASE_URL}/storefront-ui-assets/wiley_logo2.png`;

export const WILEYCOM_HOST_URL = process.env
  .REACT_APP_WILEYCOM_HOST_URL as string;
export const VET_HOST_URL = process.env.REACT_APP_VET_HOST_URL as string;
export const AGS_HOST_URL = process.env.REACT_APP_AGS_HOST_URL as string;
export const SPECTRABASE_HOST_URL = process.env
  .REACT_APP_SPECTRABASE_HOST_URL as string;
export const CUSTOMER_PORTAL_URL = process.env
  .REACT_APP_CUSTOMER_PORTAL_URL as string;
export const WILA_READER_HOST_URL = process.env
  .REACT_APP_WILA_READER_URL as string;
export const AIGATEWAY_HOST_URL = process.env
  .REACT_APP_AIGATEWAY_HOST_URL as string;
export const SUPPORT_URL = process.env.REACT_APP_SUPPORT_URL as string;
export const SITE_CONFIG_API_URL = process.env
  .REACT_APP_SITE_CONFIG_API_URL as string;
export const CONNECT_AUTH_URL = process.env
  .REACT_APP_CONNECT_AUTH_URL as string;

export const RETURN_HOME_URL = 'https://www.wiley.com';
export const CONTACT_US_URL = 'https://www.wiley.com/contact';

export const DEFAULT_LOCALE = 'en-us';

export const PHYSICAL_QTY_MAX_FOR_B2C = 10;
export const DEFAULT_SITE_ID = SiteId.WILEYCOM;
export const DEFAULT_SITE_CODE = 'WIL';

export const APP_MODE = process.env.REACT_APP_MODE as string;
export const COOKIE_DOMAIN = '.wiley.com';
export const AGS_COOKIE_DOMAIN = '.graphicstandards.com';
export const SPECTRABASE_COOKIE_DOMAIN =
  APP_MODE == 'production' ? 'spectrabase.com' : '.spectrabase.com';
export const ECOM_COOKIE_KEY = 'wiley-b2c-auth-token';
export const disableCaptchaForAutomation = APP_MODE !== 'production';

export const ENTITLEMENT_POLLING_CONFIG = {
  MAX_ATTEMPTS: 70,
  INTERVAL_MS: 5000,
} as const;
